import { AppUrl } from './app-url';
import { environment } from "../environments/environment";

export class AppConfig {

    app_host: string = '';
    minha_loga_host: string = '';
    minha_loga_version: number;

    private url = new AppUrl();

    constructor()
    {
        this.app_host = this.url.host;
        this.minha_loga_host = this.url.host_minha_loga;
        this.minha_loga_version = this.url.minha_loga_version;

        if(environment.production) {
            this.app_host = 'https://admapp.loga.net.br';
            this.minha_loga_host = 'https://minhaloga.loga.net.br/#';
        }
    }
}



// WEBPACK FOOTER //
// /var/www/minhaloga-cliente/src/app/app-config.ts